import { update } from '@/common/utils/updateApp'
import { mapState, mapActions, mapGetters } from 'vuex'
import { localset } from 'Utils/storage.js'
import { parseQueryString } from 'Utils/string.js'

export default {
  computed: {
    ...mapGetters(['loginConfig', 'userInfo', 'loginNotices']),
    ...mapState({
      authorizationPnosMap: state => state.app.authorizationPnosMap,
    })
  },
  data: function () {
    return {
      homeType: '1',
      longLvCompanySuperArr: ['707d83c7894b4ae08cc69a519f88fe8e', '591f43bf7fef47d8aa04a425e176d700'],// 龙旅公司的 CompanySuper 含测试和生产
      isLongLv: false,// 是否是龙旅
    }
  },
  created () {
    //把这里的调取放到他们自己的ceated里面去了，新页面与旧页面
    // this.getLoginNotice(0) //获取登录公告
    // this.getBadgeCount()
    // this.checkOpenId()
  },
  mounted () {
    // 龙旅标签
    if(this.userInfo && this.userInfo.vipCorp && this.longLvCompanySuperArr.includes(this.userInfo.vipCorp.companySuper)){
      this.isLongLv = true
    }

    update() //app 更新
  },
  methods: {
    ...mapActions(['getLoginNotice', 'getBadgeCount', 'getAuthorizationPnos','queryVipParameternavbar']),
    /**
	 * 传入一维菜单数组，根据每个元素的PRO_TYPE属性 和 authorizationPnosMap比较
	 * authorization没有开通的，元素添加openDiasble: true,
	 * 元素没有PRO_TYPE属性的不做处理
	 * @param {Array} menus 一维菜单数组
	 */
    genMenu (menus) {
      const OPEN_PRO_TYPES = this.authorizationPnosMap.map(i => Number(i.productNo))
      menus.forEach(menu => {
        if (menu.PRO_TYPE && OPEN_PRO_TYPES.includes(menu.PRO_TYPE)) {
          menu.openDiasble = true
        }else{ menu.openDiasble = false}
      })
      return menus
		
    },
    to (item) {
      if (!item.openDiasble) {
        this.$toast('功能已关闭！如要启用，请联系服务商开通！')
      } else {
        this.$router.push({ path: item.link })
      }
    },
    // 检查是否有openid
    checkOpenId(){
      const obj = parseQueryString(location.href)
      if(obj && obj.openid){
        localset('openId',obj.openid)
      }
    }
  }
}
